export default {
  DONATION_WAY: '選擇捐款方式',
  DONATION_AMOUNT: '選擇捐款金額',
  DONATION_INFO: '填寫捐款人資料',
  DONATION_CONFIRM: '確認資訊',
  DONATION_CARD_INFO: '填寫付款資訊',
  DONATION_SUCCESS: '完成/取得付款資訊',
  DONATION_PERIOD: '定期定額捐款',
  DONATION_SINGLE: '單次捐款',
};
